import React, { useMemo } from 'react'
import T from 'prop-types'
import { Box, Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  CAR_CHOICE_ACCEPTED,
  CAR_CHOICE_ACCEPTED_WITH_REPRICE,
} from 'lib/carChoicesLib'

import ChoiceRecap from 'components/atoms/ChoiceRecap'

import {
  FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE,
  FILTER_CARS_BOOKED_TYPE_ACCEPTED_CHOICE,
  FILTER_CARS_BOOKED_TYPE_NONE_CHOICE,
  FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE,
  FILTER_CARS_BOOKED_TYPE_ACCEPTED_WITH_REPRICE,
} from 'hooks/useCarsFilters'

import { getCarsBookedRecapValues } from './carsBookedLib'

export default function CarsBookedChoicesRecap({
  cars = [],
  filters,
  isSessionClosed,
  setFilteringRecapValues,
}) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')

  const choices = useMemo(
    () => getCarsBookedRecapValues(cars, isSessionClosed),
    [cars, isSessionClosed]
  )

  return (
    <>
      <Stack
        direction="row"
        flexWrap="wrap"
        data-testid="cars-booked-choices-recap"
      >
        <ChoiceRecap
          id="total"
          title={t('carsBooked.labelTitle.allCars')}
          value={choices.total}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_NONE_CHOICE)
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE}
          title={t('carsBooked.labelTitle.assigned')}
          value={choices.assigned || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE)
          }
          selected={
            filters.carsBookedType === FILTER_CARS_BOOKED_TYPE_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE}
          title={t('carsBooked.labelTitle.notAssigned')}
          value={choices.notAssigned || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE)
          }
          selected={
            filters.carsBookedType ===
            FILTER_CARS_BOOKED_TYPE_NOT_ASSIGNED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_ACCEPTED_CHOICE}
          title={t(`carsBooked.labelTitle.${CAR_CHOICE_ACCEPTED}`)}
          value={choices.acceptedChoice || '-'}
          handleClick={() =>
            setFilteringRecapValues(FILTER_CARS_BOOKED_TYPE_ACCEPTED_CHOICE)
          }
          selected={
            filters.carsBookedType === FILTER_CARS_BOOKED_TYPE_ACCEPTED_CHOICE
          }
          border
        />
        <Box pr={1} />
        <ChoiceRecap
          id={FILTER_CARS_BOOKED_TYPE_ACCEPTED_WITH_REPRICE}
          title={t(`carsBooked.labelTitle.${CAR_CHOICE_ACCEPTED_WITH_REPRICE}`)}
          value={choices.acceptedWithRepriceChoice || '-'}
          handleClick={() =>
            setFilteringRecapValues(
              FILTER_CARS_BOOKED_TYPE_ACCEPTED_WITH_REPRICE
            )
          }
          selected={
            filters.carsBookedType ===
            FILTER_CARS_BOOKED_TYPE_ACCEPTED_WITH_REPRICE
          }
          border
        />
        <Box pr={2} />
        <Divider orientation="vertical" variant="middle" flexItem />
        <ChoiceRecap
          title={t(
            `carsBooked.labelTitle.${
              isSessionClosed ? 'totalValueAssigned' : 'totalValueSelected'
            }`
          )}
          value={
            choices.totalValue
              ? `€ ${numberFormatter.format(choices.totalValue)}`
              : '-'
          }
        />
      </Stack>
    </>
  )
}

CarsBookedChoicesRecap.propTypes = {
  cars: T.array,
  filters: T.object,
  setFilteringRecapValues: T.func,
}
